const axios = require("axios");

var getKhaoSatTruong = () => {
    return axios
        .get(`${process.env.VUE_APP_API}${process.env.VUE_APP_KS_TRUONG}`)
        .then((response) => response)
        .catch((error) => error.response);
};

export const KhaoSatService = {
    getKhaoSatTruong
};
